/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type InventoryItemFragment = { inventoryId: string, itemId: string, quantity?: number | null, orderType: Types.OrderType, availableFromDateUtc: string, availableToDateUtc: string, displayFromDateUtc?: string | null, displayToDateUtc?: string | null, isConsignment?: boolean | null, isPreferredNoosWarehouse?: boolean | null, isNotConsumable?: boolean | null, inventoryExternalId?: string | null };

export type ProductIconsFragment = { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null };

export type ProductQueryVariables = Types.Exact<{
  brandId: Types.Scalars['String']['input'];
  productId: Types.Scalars['String']['input'];
  loadPrices?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  loadTrueDemand?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ProductQuery = { product?: { articleTitle: string, title: string, productId: string, displayedProductId?: string | null, brandId: string, attributes: any, masterAttributes: any, deliveryWindowType: Types.DeliveryWindowType, mainImageUrl?: string | null, isLocked?: boolean | null, neverOutOfStockType?: Types.NeverOutOfStockType | null, descriptionAttributes?: Array<{ key: string, displayName: string }> | null, icons?: { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null } | null, scaleSets?: { default: string, scales: any } | null, parent?: { productId: string, mainImageUrl?: string | null, isLocked?: boolean | null, parent?: { isLocked?: boolean | null, productId: string, mainImageUrl?: string | null } | null } | null, prepacks?: Array<{ productId: string, brandId: string, title: string, quantities: Array<{ quantity: number, productId: string }>, inventoryItems?: Array<{ inventoryId: string, itemId: string, quantity?: number | null, orderType: Types.OrderType, availableFromDateUtc: string, availableToDateUtc: string, displayFromDateUtc?: string | null, displayToDateUtc?: string | null, isConsignment?: boolean | null, isPreferredNoosWarehouse?: boolean | null, isNotConsumable?: boolean | null, inventoryExternalId?: string | null }> | null, priceRanges: Array<{ discount?: { min?: number | null, max?: number | null } | null }> }> | null, children?: Array<{ articleTitle: string, title: string, description?: string | null, productId: string, deliveryWindowType: Types.DeliveryWindowType, displayedProductId?: string | null, brandId: string, colorCode?: string | null, parentId?: string | null, productType: Types.ProductType, isLocked?: boolean | null, mainImageUrl?: string | null, attributes: any, masterAttributes: any, neverOutOfStockType?: Types.NeverOutOfStockType | null, descriptionAttributes?: Array<{ key: string, displayName: string }> | null, media: Array<{ url: string, urls?: Array<string> | null, type: Types.MediaType }>, children?: Array<{ productId: string, attributes: any, masterAttributes: any, inventoryItems?: Array<{ inventoryId: string, itemId: string, quantity?: number | null, orderType: Types.OrderType, availableFromDateUtc: string, availableToDateUtc: string, displayFromDateUtc?: string | null, displayToDateUtc?: string | null, isConsignment?: boolean | null, isPreferredNoosWarehouse?: boolean | null, isNotConsumable?: boolean | null, inventoryExternalId?: string | null }> | null }> | null, icons?: { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null } | null }> | null, media: Array<{ url: string, urls?: Array<string> | null, type: Types.MediaType }> } | null };

export const InventoryItemFragmentDoc = gql`
    fragment InventoryItem on InventoryItem {
  inventoryId
  itemId
  quantity
  orderType
  availableFromDateUtc
  availableToDateUtc
  displayFromDateUtc
  displayToDateUtc
  isConsignment
  isPreferredNoosWarehouse
  isNotConsumable
  inventoryExternalId
}
    `;
export const ProductIconsFragmentDoc = gql`
    fragment ProductIcons on ProductIcons {
  hasSustainableChoiceIcon
  hasPopularityIcon
  hasGlobalNoosIcon
  marketingSupportEolDate
  hasMarketingSupportIcon
  hasNewIconByDeliveryMonth
}
    `;
export const ProductDocument = gql`
    query Product($brandId: String!, $productId: String!, $loadPrices: Boolean, $loadTrueDemand: Boolean) {
  product(
    brandId: $brandId
    productId: $productId
    loadPrices: $loadPrices
    loadTrueDemand: $loadTrueDemand
  ) {
    articleTitle
    title
    productId
    displayedProductId
    brandId
    attributes
    masterAttributes
    deliveryWindowType
    mainImageUrl
    descriptionAttributes {
      key
      displayName
    }
    icons {
      ...ProductIcons
    }
    scaleSets {
      default
      scales
    }
    parent {
      productId
      mainImageUrl
      isLocked
      parent {
        isLocked
        productId
        mainImageUrl
      }
    }
    prepacks {
      productId
      brandId
      title
      quantities {
        quantity
        productId
      }
      inventoryItems {
        ...InventoryItem
      }
      priceRanges {
        discount {
          min
          max
        }
      }
    }
    children {
      articleTitle
      title
      description
      productId
      deliveryWindowType
      displayedProductId
      brandId
      colorCode
      parentId
      productType
      isLocked
      mainImageUrl
      attributes
      masterAttributes
      descriptionAttributes {
        key
        displayName
      }
      media {
        url
        urls
        type
      }
      children {
        productId
        attributes
        masterAttributes
        inventoryItems {
          ...InventoryItem
        }
      }
      neverOutOfStockType
      icons {
        ...ProductIcons
      }
    }
    isLocked
    media {
      url
      urls
      type
    }
    neverOutOfStockType
    parent {
      mainImageUrl
    }
  }
}
    ${ProductIconsFragmentDoc}
${InventoryItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductGQL extends Apollo.Query<ProductQuery, ProductQueryVariables> {
    document = ProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }